import { useState } from 'react';
import { HOT_COMMENTS } from '@/mocks/chiliao';

const QUICK = ['补一条', '蹲一个合集', '我来垫话'];

export default function CommentsZone() {
  const [text, setText] = useState('');

  return (
    <section id="comments" className="w-full scroll-mt-16 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-2 border-l-4 border-accent-500 pl-4 md:flex-row md:items-end md:justify-between md:gap-6">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-accent-700">
              <i className="ri-chat-smile-3-line text-sm" /> Loudest Corner
            </span>
            <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              热评现场 · 全场最有料
            </h2>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            弹幕和评论区，是吃料最上头的一部分。来看看这一周被顶到最前面的声音。
          </p>
        </div>

        {/* 评论卡 */}
        <div className="mt-9 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {HOT_COMMENTS.map((c) => (
            <figure
              key={c.id}
              className="flex gap-3 rounded-2xl rounded-tl-sm border border-background-200 bg-background-50 p-4 md:gap-4 md:p-5"
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-200 font-heading text-sm font-bold text-secondary-900">
                {c.user.slice(0, 1)}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-950">{c.user}</span>
                    <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
                      {c.tag}
                    </span>
                  </div>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-700">
                    <i className="ri-heart-3-fill text-sm" />
                    {c.likes.toLocaleString()}
                  </span>
                </div>
                <blockquote className="mt-2 text-sm leading-6 text-foreground-700">
                  “{c.text}”
                </blockquote>
              </div>
            </figure>
          ))}
        </div>

        {/* 伪评论输入 */}
        <div className="mt-8 rounded-2xl border border-background-200 bg-background-50 p-4 md:p-5">
          <div className="flex items-center gap-3 rounded-full bg-background-100 px-4 py-2">
            <i className="ri-chat-3-line text-lg text-foreground-400" />
            <input
              value={text}
              onChange={(e) => setText(e.target.value)}
              type="text"
              placeholder="这页上有什么想聊的？垫一句，占个前排……"
              className="w-full flex-1 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              maxLength={100}
            />
            <button
              type="button"
              className="flex h-9 items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              发送
              <i className="ri-send-plane-2-fill text-sm" />
            </button>
          </div>
          <div className="mt-3 flex flex-wrap gap-2">
            {QUICK.map((q) => (
              <button
                key={q}
                type="button"
                onClick={() => setText(q)}
                className="whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs text-foreground-600 transition-colors hover:border-secondary-300 hover:text-foreground-900"
              >
                {q}
              </button>
            ))}
            <span className="ml-auto self-center text-xs text-foreground-400">
              仅示意 · 不上传提交
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}